import { Action, createReducer, on } from "@ngrx/store";
import * as ordersActions from './orders.actions';
import { IOrder, IOrderKPI, IOrdersFilterState } from "../models/order.model";
import { refillOrdersFilter } from "src/app/shared/utils/helpers";
import { IPagination } from "src/app/shared/models/page.model";

export interface ordersState {
  orders: IOrder[],
  kpi: IOrderKPI | undefined
  loading: boolean
  ordersFilterState: IOrdersFilterState;
  metadata: IPagination | null;
  showProcessing: boolean;
}

export const initialordersState: ordersState = {
  orders: [],
  kpi: undefined,
  loading: false,
  ordersFilterState: {
    advanced: refillOrdersFilter(),
    keyword: ''
  },
  metadata: null,
  showProcessing: true,
}

const featureReducer = createReducer(
  initialordersState,
  on(
    ordersActions.GetOrdersSuccess,
    (state, action) => ({
      ...state,
      orders: action.res.object?.orders || state.orders,
      kpi: action.res.object?.kpi,
      metadata: action.res.metadata
    })
  ),
  on(
    ordersActions.SetOrdersLoader,
    (state, action) => ({
      ...state,
      loading: action.isLoading
    })),
  on(ordersActions.SetOrdersFilter, (state, action) => ({
    ...state,
    ordersFilterState: {
      advanced: action.advanced!,
      keyword : action.keyword
    }
  })),
  on(ordersActions.SetOrdersSearch, (state, action) => ({
    ...state,
    ordersFilterState: {
      ...state.ordersFilterState,
      searchOrders: action.search
    }
  })),
    on(ordersActions.exportOrders, (state) => ({
      ...state,
      loading: true,
    })),
    on(ordersActions.exportOrdersSuccess, (state) => ({
      ...state,
      loading: false,
    })),
    on(ordersActions.ToggleProcessingVisibility, (state) => ({
      ...state,
      showProcessing: !state.showProcessing,
    })),
    on(ordersActions.SetProcessingVisibility, (state, action) => ({
      ...state,
      showProcessing: action.visible,
    }))
)

export function ordersReducer(state: ordersState | undefined, action: Action) {
  return featureReducer(state, action);
}
